import type { ReactNode } from 'react'

import ArticleIcon from '@mui/icons-material/Article'
import { AppBar, Box, Button, Container, Toolbar, Typography } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'

import { useAuth } from '../../modules/auth/hooks/useAuth'

type LayoutProps = {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const canAccessAdminPanel = user ? ['admin', 'publisher'].includes(user.role) : false
  const isAdmin = user?.role === 'admin'

  function handleLogout() {
    logout()
    navigate('/login')
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #0f4c81, #1f6fb2)',
          boxShadow: '0 10px 24px rgba(15, 76, 129, 0.08)',
        }}
      >
        <Toolbar>
          <ArticleIcon sx={{ mr: 1 }} />
          <Typography
            variant="h6"
            component={Link}
            to="/"
            sx={{ flexGrow: 1, color: 'inherit', textDecoration: 'none', fontWeight: 700 }}
          >
            KB Portal
          </Typography>
          {user && (
            <>
              <Typography variant="body2" sx={{ mr: 2, color: 'rgba(255,255,255,0.9)' }}>
                {user.name} ({user.role})
              </Typography>
              {canAccessAdminPanel && (
                <>
                  <Button
                    color="inherit"
                    component={Link}
                    to="/admin"
                    sx={{ mr: 1, borderRadius: 12, fontWeight: 700, textTransform: 'none' }}
                  >
                    Workflow
                  </Button>
                  <Button
                    color="inherit"
                    component={Link}
                    to="/admin"
                    state={{ tab: 1 }}
                    sx={{ mr: 1, borderRadius: 12, fontWeight: 700, textTransform: 'none' }}
                  >
                    Dropdowns
                  </Button>
                  {isAdmin && (
                    <Button
                      color="inherit"
                      component={Link}
                      to="/admin"
                      state={{ tab: 3 }}
                      sx={{ mr: 1, borderRadius: 12, fontWeight: 700, textTransform: 'none' }}
                    >
                      Users
                    </Button>
                  )}
                </>
              )}
              <Button
                color="inherit"
                onClick={handleLogout}
                sx={{ borderRadius: 12, fontWeight: 700, textTransform: 'none' }}
              >
                Logout
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4, flexGrow: 1 }}>
        {children}
      </Container>
    </Box>
  )
}
